/* START_MODULE_CONTRACT
 * PURPOSE: Frontend UI module: ProjectAvatar.
 * SCOPE: React component or page.
 * DEPENDS: M-FE-API, M-FE-AUTH
 * LINKS: M-FE-AUTH
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * ProjectAvatar - Frontend UI module: ProjectAvatar.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: function contract и парный END_METHOD.
 * END_CHANGE_SUMMARY
 */

import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import { getColorByName } from '../utils/projectColors';

/* START_METHOD_ProjectAvatar */
/* START_CONTRACT: ProjectAvatar
 * PURPOSE: Аватар проекта с первой буквой имени и детерминированным цветом.
 * INPUTS: { name: string, size?: number, sx?: object }.
 * OUTPUTS: { JSX.Element - Tooltip>Avatar }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-PROJECTS
 * END_CONTRACT: ProjectAvatar
 */
export default function ProjectAvatar({ name, size = 32, sx }) {
  const letter = name ? name[0].toUpperCase() : '?';
  const bgcolor = name ? getColorByName(name) : 'grey.400';

  return (
    <Tooltip title={name || ''} placement="top" arrow disableHoverListener={!name}>
      <Avatar
        sx={{
          width: size,
          height: size,
          fontSize: size * 0.44,
          fontWeight: 600,
          bgcolor,
          flexShrink: 0,
          ...sx,
        }}
      >
        {letter}
      </Avatar>
    </Tooltip>
  );
}
/* END_METHOD_ProjectAvatar */
